import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";

export const Footer = () => {

  const [t] = useTranslation('common');

  function openInNewTab(url) {
    window.open(url, '_blank').focus();
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "auto",
        backgroundColor: "#d6d6d8",
        paddingTop: "0.75rem",
        paddingBottom: "0.75rem",
        textAlign: "center"
      }}
    >
      <Container maxWidth="lg">
        <Grid container direction="column" alignItems="center">
          <Grid
            item xs={12}
          >
            <Typography color="black" variant="h5">
              Bus RT Insights
            </Typography>
          </Grid>
          <Grid
            item xs={12}
          >
            <Typography color="textSecondary" variant="subtitle1">
              <Link to="/licences" style={{ textDecoration: 'none', color: '#59595a' }}>
                {t("footer.license")}
              </Link>
              {` | `}
              <Link to="/privacypolicy" style={{ textDecoration: 'none', color: '#59595a' }}>
                {t("footer.privacy")}
              </Link>
              {` | `}<a style={{ textDecoration: 'none', color: '#59595a' }} href="mailto: info@busrtinsights.com">Contact</a><br />
              <a style={{ textDecoration: 'none', color: '#59595a' }} href="https://www.cardinaldatasolutions.com">Cardinal Data Solutions {` ${new Date().getFullYear()}`}</a>
              {/* {` | `}
              <Link to="/enLogin" style={{ textDecoration: 'none', color: '#59595a' }}>
                EN
              </Link> */}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;